import type MailFolderNodeViewState from '../store/schema/MailFolderNodeViewState';
import { getStore } from '../store/store';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import type { SortBy } from 'owa-mail-list-store';
import { MailSortHelper } from 'owa-mail-list-store';

export interface GetFolderViewStateFromIdState {
    folderNodeViewStates: Map<string, MailFolderNodeViewState>;
}

export const getFolderViewStateFromIdNoFallback = (
    folderId: string
): MailFolderNodeViewState | undefined => {
    return getStore().folderNodeViewStates.get(folderId);
};

export default function getFolderViewStateFromId(folderId: string): MailFolderNodeViewState {
    const folderViewState = getStore().folderNodeViewStates.get(folderId);

    if (!folderViewState) {
        return getDefaultFolderViewState();
    } else {
        return folderViewState;
    }
}

const getDefaultFolderViewState = () => {
    const defaultSortBy: SortBy = MailSortHelper.getDefaultSortBy();
    return {
        isExpanded: false,
        sortColumn: defaultSortBy.sortColumn,
        sortOrder: defaultSortBy.sortDirection,
        drag: createDragViewState(),
        drop: createDropViewState(),
        color: undefined,
        countDisplayMode: undefined,
    };
};
